import axios, { AxiosResponse } from "axios";

import {
	getRequest,
	putRequest
} from "@/Utils/Service/BackendService";
import {
	CheckListBarData,
	ClientsResponse,
	UpdateCheckListBarDataPayload
} from "../contracts";
import {
	GetVendorResourcesResponse,
	Template,
	VendorCompany
} from "@/Contracts";
import { concatBlocksAndDraftBlockInTemplateResponse } from "@/Utils/Template";

const checkListBarDataURL = "/v2/onboarding/progress";
export const updateCheckListBarDataURL = "/v2/onboarding/progress/{id}";
const demoDataURL = "/v2/onboarding/demodata/";
const documentTemplateUrl = "/v2/onboarding/document/template/";
const getVendorResourcesByVendorIdUrl =
	"/v1/marketplace/vendors/{vendor_id}/resources?parent_id={parent_id}";
const getVendorDetailsURL = "/v1/marketplace/vendors/{id}";
export const getChecklistBarData = async (): Promise<CheckListBarData> => {
	try {
		const response: AxiosResponse<CheckListBarData> = await axios(
			getRequest(checkListBarDataURL, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateCheckListBarData = async (
	id: string,
	requestPayload: UpdateCheckListBarDataPayload
): Promise<CheckListBarData> => {
	try {
		const url = updateCheckListBarDataURL.replace("{id}", id);
		const response: AxiosResponse<CheckListBarData> = await axios(
			putRequest(url, requestPayload, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getDummyClientData = async (): Promise<ClientsResponse> => {
	try {
		const response: AxiosResponse<ClientsResponse> = await axios(
			getRequest(
				demoDataURL + "?included_child_entities=client_users:all",
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getDocumentTemplateData = async (): Promise<Template> => {
	try {
		const response: AxiosResponse<Template> = await axios(
			getRequest(documentTemplateUrl, null, true, false, false)
		);
		return concatBlocksAndDraftBlockInTemplateResponse(response.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getVendorResourcesByVendorId = async (
	vendorId: string,
	parentId: string
): Promise<GetVendorResourcesResponse> => {
	try {
		const response: AxiosResponse<GetVendorResourcesResponse> = await axios(
			getRequest(
				getVendorResourcesByVendorIdUrl
					.replace("{vendor_id}", vendorId)
					.replace("{parent_id}", parentId),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getVendorDetails = async (
	vendorId: string
): Promise<VendorCompany> => {
	try {
		const response: AxiosResponse<VendorCompany> = await axios(
			getRequest(
				getVendorDetailsURL.replace("{id}", vendorId),
				null,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};
